import { Component, Input } from '@angular/core';
import { Aufteilungsschluessel } from '../../domain/model/datenabfrage/aufteilungsschluessel';

@Component({
    selector: 'tnb-aufteilungsschluessel-list',
    templateUrl: './aufteilungsschluessel-list.component.html',
    styleUrls: [
        './aufteilungsschluessel-list.component.scss',
    ],
    standalone: false,
})
export class AufteilungsschluesselListComponent {

    @Input() aufteilungsSchluessels: Aufteilungsschluessel[] | [];

    constructor() {
    }

}
